<template>

    <div>

        <div class="nk-block">
            <div class="row g-gs">
                <div class="col">
                    <span>participants present: {{ numberOfTeamsPresent }} / {{ totalRegistrations }} ({{ Math.round((numberOfTeamsPresent/totalRegistrations * 100)) }}%)</span>
                </div>
            </div>
        </div>

        <div class="nk-block">
            <div class="row g-gs">
                <!-- Here, we will have the manual team number input -->

                <div class="col-9">
                    <div class="form-group">
                        <label class="form-label">{{ translations.team_number_input }}</label>
                        <div class="form-control-wrap">
                            <input id="teamNumberInput" type="number" class="form-control" v-on:keyup="fetchTeamData" :placeholder="translations.team_number_input">
                        </div>
                    </div>
                </div>

                <div class="col-3 d-flex justify-content-end">
                    <div class="form-group">
                        <label class="form-label">&nbsp;</label>
                        <div class="form-control-wrap">
                            <button class="btn btn-primary" v-on:click="enableScanListener">
                                <em class="fas fa-qrcode"></em>&nbsp; {{ translations.scan_qr_code }}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="Object.keys(registration).length !== 0">

            <hr>

            <div class="nk-block">

                <div v-if="!registration.paid" class="row g-gs pt-3 pb-3">
                    <div class="col-12">
                        <div class="alert alert-fill alert-icon alert-danger" role="alert">
                            <em class="icon ni ni-alert-circle"></em>
                            <strong>This registration was not paid!</strong> We still need the amount of <strong v-html="formatPrice(registration.total_cost)"></strong> to allow the competitors to participate.
                        </div>
                    </div>
                </div>

                <!-- We add some action buttons here, to scan the next person and approve the team -->
                <div class="row g-gs">

                    <div class="col d-flex justify-content-end">
                        <button v-if="!registration.paid" class="btn btn-warning mr-3" v-on:click="markAsPaid">
                            <em class="icon ni ni-check-thick"></em><span>{{ translations.mark_as_paid }}</span>
                        </button>
                        <button v-if="!registration.is_present" class="btn btn-success" v-on:click="markTeamAsPresent">
                            <em class="icon ni ni-check-thick"></em><span>{{ translations.mark_team_as_present }}</span>
                        </button>
                        <button v-else class="btn btn-success disabled" disabled>
                            <em class="icon ni ni-check-thick"></em><span>{{ translations.team_is_present }}</span>
                        </button>
                    </div>

                </div>

                <!-- Competitor and catering data -->
                <div class="row g-gs">

                    <!-- Here we will have the quick overview of the competitors (only the licenses and stuff we display here) -->
                    <!-- Add a quick and easy way to have an overview of the user's their data AND licenses to also check if they are OK or not. -->

                    <div class="col-12 d-flex justify-content-center">
                        <h4>{{ translations.team }} <span v-text="registration.team_number"></span></h4>
                    </div>

                    <!-- Catering lists -> so we know what we need to give -->
                    <div class="col-md-12">

                        <div class="row gy-gs pb-3">
                            <div class="col-sm-6 col-lg-4 col-xxl-3" v-for="cateringItem in catering">
                                <div class="card card-bordered">

                                    <div class="card-inner">
                                        <div class="team">

                                            <div class="user-card user-card-s2">
                                                <div class="user-info">
                                                    <h6 v-text="cateringItem.name"></h6>
                                                </div>
                                            </div>
                                            <div class="team-details">
                                                <div class="form-group">
                                                    <label class="form-label">{{ translations.amount }}</label>
                                                    <div class="form-control-wrap">
                                                        <input class="form-control" disabled :value="cateringItem.pivot.amount" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- pilot -->
                    <div class="col-md-6">

                        <h4 class="pb-2 mb-3">{{ translations.pilot }}</h4>

                        <!-- License or Eid images block -->
                        <div class="nk-block" v-if="pilot.media">
                            <div class="row g-gs">
                                <div class="col-sm-6 col-lg-4" v-for="media in pilot.media">
                                    <div class="gallery card card-bordered" :class="getLicenseColor(pilot)">
                                        <a class="gallery-image popup-image" target="_blank" :href="media.original_url">
                                            <img class="w-100 rounded-top rounded-bottom eid" :src="media.original_url" :alt="media.name">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-gs">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[firstname]">{{ translations.firstname }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[firstname]" v-model="pilot.firstname" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[lastname]">{{ translations.lastname }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[lastname]" v-model="pilot.lastname" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[email]">{{ translations.email }}</label>
                                    <div class="form-control-wrap">
                                        <input type="email" class="form-control required" id="pilot[email]" name="pilot[email]" v-model="pilot.email" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group row">
                                    <div class="col-6">
                                        <label for="pilot[is_resident]">{{ translations.resident }}</label>
                                        <div class="g">
                                            <div class="custom-control custom-control-sm custom-checkbox">
                                                <input type="checkbox" value="true" class="custom-control-input" id="pilot[is_resident]" v-model="pilot.is_resident" @change="updateTeamData">
                                                <label class="custom-control-label" for="pilot[is_resident]"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <label for="pilot[is_female]">{{ translations.female }}</label>
                                        <div class="g">
                                            <div class="custom-control custom-control-sm custom-checkbox">
                                                <input type="checkbox" value="true" class="custom-control-input" id="pilot[is_female]" v-model="pilot.is_female" @change="updateTeamData">
                                                <label class="custom-control-label" for="pilot[is_female]"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[street]">{{ translations.street }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[street]" name="pilot[street]" v-model="pilot.street" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[number]">{{ translations.number }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[number]" name="pilot[number]" v-model="pilot.number" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[city]">{{ translations.city }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[city]" name="pilot[city]" v-model="pilot.city" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[zipcode]">{{ translations.zipcode }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[zipcode]" name="pilot[zipcode]" v-model="pilot.zipcode" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[club]">{{ translations.club }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[club]" name="pilot[club]" v-model="pilot.club" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="pilot[license_number]">{{ translations.license }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="pilot[license_number]" name="pilot[license_number]" v-model="pilot.license_number" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Co-pilot -->
                    <div class="col-md-6">

                        <h4 class="pb-2 mb-3">{{ translations.copilot}}</h4>

                        <!-- License or Eid images block -->
                        <div class="nk-block" v-if="copilot.media">
                            <div class="row g-gs">
                                <div class="col-sm-6 col-lg-4" v-for="media in copilot.media">
                                    <div class="gallery card card-bordered" :class="getLicenseColor(copilot)">
                                        <a class="gallery-image popup-image" target="_blank" :href="media.original_url">
                                            <img class="w-100 rounded-top rounded-bottom eid" :src="media.original_url" :alt="media.name">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row g-gs">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[firstname]">{{ translations.firstname }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[firstname]" v-model="copilot.firstname" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[lastname]">{{ translations.lastname }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[lastname]" v-model="copilot.lastname" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[email]">{{ translations.email }}</label>
                                    <div class="form-control-wrap">
                                        <input type="email" class="form-control required" id="copilot[email]" name="copilot[email]" v-model="copilot.email" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group row">
                                    <div class="col-6">
                                        <label for="copilot[is_resident]">{{ translations.resident }}</label>
                                        <div class="g">
                                            <div class="custom-control custom-control-sm custom-checkbox">
                                                <input type="checkbox" value="true" class="custom-control-input" id="copilot[is_resident]" v-model="copilot.is_resident" @change="updateTeamData">
                                                <label class="custom-control-label" for="copilot[is_resident]"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <label for="copilot[is_female]">{{ translations.female }}</label>
                                        <div class="g">
                                            <div class="custom-control custom-control-sm custom-checkbox">
                                                <input type="checkbox" value="true" class="custom-control-input" id="copilot[is_female]" v-model="copilot.is_female" @change="updateTeamData">
                                                <label class="custom-control-label" for="copilot[is_female]"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[street]">{{ translations.street }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[street]" name="copilot[street]" v-model="copilot.street" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[number]">{{ translations.number }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[number]" name="copilot[number]" v-model="copilot.number" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[city]">{{ translations.city }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[city]" name="copilot[city]" v-model="copilot.city" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[zipcode]">{{ translations.zipcode }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[zipcode]" name="copilot[zipcode]" v-model="copilot.zipcode" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[club]">{{ translations.club }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[club]" name="copilot[club]" v-model="copilot.club" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label" for="copilot[license_number]">{{ translations.license }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control required" id="copilot[license_number]" name="copilot[license_number]" v-model="copilot.license_number" @change="updateTeamData">
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <!-- Vehicle -->
                <div class="row g-gs mt-3">

                    <div class="col-12">
                        <h4 class="pt-5">{{ translations.vehicle }}</h4>
                    </div>

                    <div class="col-6">
                        <div class="form-group">
                            <label class="form-label" for="vehicle[brand]">{{ translations.vehicle_brand }}</label>
                            <div class="form-control-wrap">
                                <input type="text" class="form-control" id="vehicle[brand]" name="vehicle[brand]" v-model="vehicle.brand">
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group">
                            <label class="form-label" for="vehicle[type]">{{ translations.vehicle_type }}</label>
                            <div class="form-control-wrap">
                                <input type="text" class="form-control" id="vehicle[type]" name="vehicle[type]" v-model="vehicle.type">
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <label class="form-label">{{ translations.vehicle_build_year }}</label>
                        <div class="form-group" style="margin-top: -31px;">
                            <label class="form-label" for="vehicle[build_year]">&nbsp;</label>
                            <div class="form-control-wrap">
                                <div class="form-control-select">
                                    <select class="form-control" id="vehicle[build_year]" name="vehicle[build_year]" v-model="vehicle.build_year">
                                        <option v-for="year in years" :value="year">{{ year }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label class="form-label" for="vehicle[license_plate]">{{ translations.vehicle_license_plate }}</label>
                            <div class="form-control-wrap">
                                <input type="text" class="form-control" id="vehicle[license_plate]" name="vehicle[license_plate]" v-model="vehicle.license_plate">
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- Modal Content Code -->
        <div class="modal fade" tabindex="-1" id="scannerModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <a href="javascript:void(0)" class="close" data-dismiss="modal" aria-label="Close" v-on:click="disableScanListener">
                        <em class="icon ni ni-cross"></em>
                    </a>
                    <div class="modal-header">
                        <h5 class="modal-title">{{ translations.scan_qr_code_modal_title }}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-gs d-flex justify-content-center pt-5">
                            <div class="spinner-border text-info" role="status"></div>
                        </div>
                        <div class="row g-gs d-flex justify-content-center pt-4 pb-5">
                            <span v-if="!display_processing_qr">{{ translations.awaiting_scan }}</span>
                            <span v-if="display_processing_qr">{{ translations.processing_scan }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: "registrationCheck",

    props: [
        'event',
        'translations',
    ],

    data() {
        return {
            display_processing_qr: false,
            QRCode: '',
            registration: {},
            pilot: {},
            copilot: {},
            vehicle: {},
            catering: {},
            totalRegistrations: 0,
            numberOfTeamsPresent: 0,
        }
    },

    computed: {
        years() {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1899}, (value, index) => 1900 + index).reverse()
        }
    },

    mounted() {
        this.updatePresentTeamsData();
    },

    methods: {

        enableScanListener() {

            this.QRCode = ''; // reset the QR code every time :)
            window.addEventListener('keypress', this.scanQrCode, false);

            $('#scannerModal').modal({backdrop: 'static', keyboard: false});

            console.log('Event listener has been added');
        },
        disableScanListener() {
            this.QRCode = ''; // reset the QR code every time :)
            window.removeEventListener('keypress', this.scanQrCode, false);

            $('#scannerModal').modal('hide');

            this.display_processing_qr = false;

            console.log('Event listener has been destroyed');
        },

        scanQrCode(e) {
            const char = String.fromCharCode(e.keyCode);

            // 13 = 'enter'
            if (e.keyCode === 13) {

                this.processCode(); // Will process the decoded QR code

            } else {
                this.QRCode += char;
            }
        },

        processCode() {
            try {
                // let codeData = JSON.parse(this.QRCode); // decode the json

                this.display_processing_qr = true; // visual update

                // reset all the objects
                this.registration = {};
                this.pilot = {};
                this.copilot = {};
                this.vehicle = {};
                this.catering = {};

                let identifier = '';

                try {
                    identifier = JSON.parse(this.QRCode).identifier;
                } catch (e) {
                    identifier = this.QRCode;
                }

                axios.post('/api/internal/registration-check/fetch-team-data', {
                    // type: codeData.type,
                    identifier: identifier,
                    event_id: this.event.id
                }).then((response) => {
                    this.registration = response.data;
                    this.pilot = response.data.pilot;
                    this.copilot = response.data.copilot;
                    this.vehicle = response.data.vehicle;
                    this.catering = response.data.catering;

                    $('#teamNumberInput').val(this.registration.team_number);

                    this.disableScanListener();

                }).catch((errors) => {
                    if (errors.response) {
                        if (errors.response.status === 404) {
                            NioApp.Toast(this.translations.team_not_found, 'warning', {position: 'top-right', timeOut: 5000});
                        }
                    } else {
                        console.log(errors)
                        NioApp.Toast(this.translations.internal_error, 'error', {position: 'top-right', timeOut: 5000});
                    }
                    this.QRCode = ''; // Important, on error, we reset the QR code.
                    this.display_processing_qr = false;
                });

            } catch (e) {
                console.log(e)
                NioApp.Toast(this.translations.internal_error, 'error', {position: 'top-right', timeOut: 5000});
                this.QRCode = ''; // Important, on error, we reset the QR code.
                this.display_processing_qr = false;
            }
        },

        fetchTeamData(e) {
            e.preventDefault();

            if ($(e.currentTarget).val().length > 2) {
                // reset all the objects
                this.registration = {};
                this.pilot = {};
                this.copilot = {};
                this.vehicle = {};
                this.catering = {};

                axios.post('/api/internal/registration-check/fetch-team-data', {
                    team_number: $(e.currentTarget).val(),
                    event_id: this.event.id
                }).then((response) => {
                    this.registration = response.data;
                    this.pilot = response.data.pilot;
                    this.copilot = response.data.copilot;
                    this.vehicle = response.data.vehicle;
                    this.catering = response.data.catering;
                }).then(() => {
                    this.updatePresentTeamsData();
                }).catch((errors) => {
                    if (errors.response) {
                        if (errors.response.status === 404) {
                            NioApp.Toast(this.translations.team_not_found, 'warning', {position: 'top-right', timeOut: 5000});
                        }
                    } else {
                        NioApp.Toast(this.translations.internal_error, 'error', {position: 'top-right', timeOut: 5000});
                    }
                });
            }
        },

        updateTeamData() {
            axios.post('/api/internal/registration-check/update-team-data', {
                team_number: $('#teamNumberInput').val(),
                event_id: this.event.id,
                pilot: this.pilot,
                copilot: this.copilot,
                vehicle: this.vehicle,
            }).then((response) => {
                this.registration = response.data;
                this.pilot = response.data.pilot;
                this.copilot = response.data.copilot;
                this.vehicle = response.data.vehicle;
                this.catering = response.data.catering;
            });
        },

        updatePresentTeamsData() {
            axios.get('/api/internal/registration-check/get-present-teams', {
                params: {
                    event_id: this.event.id
                }
            }).then((response) => {
                this.totalRegistrations = response.data.total_registrations;
                this.numberOfTeamsPresent = response.data.number_of_teams_present;
            }).catch((err) => {
                //
            });
        },

        markTeamAsPresent() {
            this.registration.is_present = true; // quickest visual update

            // post
            axios.post('/api/internal/registration-check/mark-as-present', {
                registration_id: this.registration.id
            }).then((response) => {
                NioApp.Toast(this.translations.marked_as_present, 'success', {position: 'top-right', timeOut: 5000});
            }).then(() => {
                this.updatePresentTeamsData();
            }).catch((errors) => {
                NioApp.Toast(this.translations.internal_error, 'error', {position: 'top-right', timeOut: 5000});
            });
        },

        markAsPaid() {
            this.registration.paid = true; // quickest visual update

            // post
            axios.post('/api/internal/registration-check/mark-as-paid', {
                registration_id: this.registration.id
            }).then((response) => {
                NioApp.Toast(this.translations.marked_as_paid, 'success', {position: 'top-right', timeOut: 5000});
            }).catch((errors) => {
                NioApp.Toast(this.translations.internal_error, 'error', {position: 'top-right', timeOut: 5000});
            });
        },

        getLicenseColor(competitor) {
            if (!competitor.day_license) {
                switch (competitor.license_status) {
                    case 0:
                        return 'license-pending';
                    case 1:
                        return 'license-valid';
                    case 2:
                        return 'license-invalid';
                }
            }
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')

            return '&euro; ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
    }
}
</script>

<style scoped>

.license-valid {
    box-shadow: 0 0 5px 8px rgba(30, 224, 172, 0.35);
}

.license-invalid {
    box-shadow: 0 0 5px 8px rgba(232, 83, 71, 0.35);
}

.license-pending {
    box-shadow: 0 0 5px 8px rgba(244, 189, 14, 0.35);
}

</style>
